import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from "@angular/core";
import { UrlService } from "src/app/services/url.service";
import { MatTooltip } from "@angular/material/tooltip";

import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  imports: [MatTooltip, MatProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  text = input.required<string>();
  type = input<"primary" | "secondary">("primary");
  disabled = input<boolean>(false);
  isLoading = input<boolean>(false);
  pulse = input<boolean>(false);
  matchingborderBg = input<boolean>(false);
  tooltipText = input<string | undefined>();

  clicked$ = output<MouseEvent>();

  constructor(public urlService: UrlService) {}

  onClick = (event: MouseEvent) => this.clicked$.emit(event);
}
